export default {
    OurServices:'Our Services',
    contentP:"Seeder is continuously developing credit scoring and customer profiling service. You can subscribe this through Seeder.",
   
    ServiceTypes:'Service Types',
    CreditScoreDevelopment:"Credit Score Development",
    contentP2:"Developing credit scoring system with a strong foundation of credit history and alternative data to better measure the risks of your customers.",
    SubscribeourscoringAPlviaSeeder:"Subscribe our scoring APl via Seeder",
    contentP3:'Seeder is user management system, enabling user to easily subscribe to API products.',
    
    CreditScore: "Credit Score Development",
    DeepLearning:"Deep Learning, Machine Learning Techniques  Big Data for Predictive Credit Score",
    DeepLearningContent:"Our credit scoring system combines the conventional credit history and alternative data to have a 360 customer's view to accurately predict the risk profile of an incoming loan application.",
    Wecontinuously:"We continuously improve and add more relevant scores from our exploration and development cycles by refining each step: capturing data, update model, and measure.",
    
    AlternativeData:"Alternative Data for Better Financial Decision",
    Ourdatalayer:"Our data layer engine helps financial institutions and business partners to leverage alternative data, with the user's consent, for making credit decisions.",
    xinyongtext1:"Financial lnstitutions",
    xinyongtext2:"E-Wallet",
    xinyongtext3:"E-Commerce",
    xinyongtext4:"Ride Hailing",
    xinyongtext5:"Online Travel Agent",
    xinyongtext6:"And many more...",
    Thesedatawill:"These data will then be used as one of the creditworthiness measurements. Credit worthiness is based on financial health, credit discipline, identity, behavior & preferences and social relationships.",
    
    Download:"Credit Report Demo Download",
};
